module.exports = (value) => {

    if (isNaN(value)) return 0;
    return new Intl.NumberFormat('en-US').format(value);
    // Expected output: "123.;
  };